import React, { Component } from 'react'
import { useQuery } from 'react-query'
import Fetcher from '../../../hoc/FetcherSetting/FetcherSetting'
import { useParams } from 'react-router'
import { useHistory } from "react-router-dom";
import moment from 'moment';
import axios from 'axios';
import { APIURL } from '../../../hoc/AxiosSetting/axios';
import ToastInstance from '../../../hoc/NotificationSettings/ToastInstance';
import S3FileUpload from 'react-s3';
import swal from '@sweetalert/with-react';

export default class ViewAuditTeamProposal extends Component {
    constructor(props) {
        super(props)
        this.state = {
        //   orgCode : props.match.params.orgcode,
        //   auditteamurl: "",
        message:"",
        showMessage:false,
        reportOfreviewProcess: {
            orgCode : props.match.params.orgcode,
            auditteamurl: "",
          
        },
          data: {},
          config: {
            bucketName: process.env.REACT_APP_BUCKET_NAME,
            dirName: process.env.REACT_APP_DIR_NAME /* optional */,
            region: process.env.REACT_APP_REGION,
            accessKeyId: process.env.REACT_APP_ACCESS_ID,
            secretAccessKey: process.env.REACT_APP_ACCESS_KEY,
        },
        editStatus:false,
        buttonStatus: "none",
        downloadbuttonStatus: "none",
        uploadDocumentStatus: "none",
        uploadedDocumentStatus: "none",
        showFile: "Image",
        uploadedProcessUrl: "",
        submitStatus: false,
        uploadStatus : true,
        messageforvalidation :"none",
        isLoading:false
        }
        this.viewprocessUrlInput = React.createRef();
    }
    static getDerivedStateFromProps(props, state) {
        return { id: props.match.params.orgcode || 0 };
    }
    componentDidMount() {
        const api=APIURL + '/api/rfq/get/orgdetails/' + this.state.reportOfreviewProcess.orgCode
        axios.get(api, {headers: {
            'Authorization': 'Bearer ' + localStorage.getItem("token"),
         }})
            .then(res => {
                console.log("res",res.data.response)
                if(res.data.errorCode === 0){
                    this.setState({data : res.data.response})
                    console.log("auditteamproposalStatus", res.data.response.auditteamproposalStatus)
                    console.log("masteragreementStatus ", res.data.response.masteragreementStatus)

                    if(res.data.response.masteragreementStatus  && res.data.response.auditteamproposalStatus)
                    {
                        this.setState({editStatus:true})
                        if (this.state.data.auditteamurl ) {
                            var uplodedFileName= this.state.data.auditteamurl.split("/")
                            var uplodedFileNameToView = uplodedFileName[4]
                            this.setState({ uploadedProcessUrl: this.state.data.auditteamurl ,uploadedFileNameToshow: uplodedFileNameToView})
                            this.setState({ uploadDocumentStatus: "none", uploadedDocumentStatus: "block", downloadbuttonStatus: "none" })
                        }
                        else if (!this.state.data.auditteamurl) {
                            this.setState({ uploadDocumentStatus: "block", uploadedDocumentStatus: "none", downloadbuttonStatus: "block" })
                        }
                    } else if(res.data.response.masteragreementStatus && !res.data.response.auditteamproposalStatus)
                    {
                        this.setState({editStatus:true,message:"Need to Fill the Audit Team Proposal Data",showMessage:true})
                    } else{
                        this.setState({ editStatus: false , message:"This Company's Aggrement is not Uploaded.",showMessage:true})
                    }
                }
            })
            .catch(e=>{
                console.log("Something went Wrong", e)
                var string = JSON.stringify(e).split("/")[0]
                const regex = /401/g;
                const found = string.match(regex);

                console.log("found", found);
                if (found !== null) {
                    window.location.href = "/signin"
                    //alert("if")
                    this.setState({isLoading:true})
                }
            })
    }
    handleprocessreview = (event) => {
        event.preventDefault();
        let newArr = this.viewprocessUrlInput.current.files[0];
        this.handleUpload(newArr);
    }
    handleUpload = (file) => {
        var file1 = Math.round((file.size / 1024));
        if(file1 <= 3072 ){
        S3FileUpload
            .uploadFile(file, this.state.config)
            .then(data => {
                console.log("data s3",data)
                var tempData =this.state.reportOfreviewProcess;
                tempData.auditteamurl = data.location
                var docType = this.checkFileExtension(data.location)
                var file= data.key.split("/")
                var fileName = file[1];
                this.setState({ auditteamurl: tempData, 
                                showFile: docType ,
                                uploadStatus :false, 
                                messageforvalidation : "none",
                                fileToUpload : data.location,
                                filenameToview : fileName
                            });
            })
            .catch(err => console.error(err))
        }
        else{
            this.setState({filenameToview : "",messageforvalidation : "block"})
        }
    }; 
    downloadUploadPdf=()=>{
        const link = document.createElement('a');
        console.log("link",link)
        link.href = this.state.fileToUpload
        window.open(link)
    }
    checkFileExtension = (file) => {
        if (file) {
            if (file.match(/\.(jpg|jpeg|png|gif)$/)) {
                return "Image"
            } else if (file.match(/\.(pdf)$/)) {
                return 'pdf'
            }
        }
    }

    removeDoc = () => {
        var tempData = this.state.reportOfreviewProcess;
        tempData.auditteamurl = ""
        this.setState({  reportOfreviewProcess: tempData ,uploadStatus :true, 
                        
                       
                    });
    }
    removeUplodedDoc = (id) => {
        swal({
            title: "Are you sure?",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    var jsonRequest ={
                                         "orgCode":this.state.data.orgCode,
                                      
                                    }
                  
                    axios.patch(APIURL + "/api/rfq/patch/auditteamurl",jsonRequest)
                    .then((res) => {
                        if (res.data.errorCode === 0) {
                           
                            this.setState({
                                uploadDocumentStatus: "block",
                                uploadedDocumentStatus: "none",
                                uploadProcessUrl: "",
                                uploadStatus: true,
                                uploadedProcessUrl: "",
                                editStatus: true
                            })
                        }
                        else {
                            ToastInstance('Error', 'Something Went Wrong')
                        }
                    })
                    .catch(err => {
                        ToastInstance('warning', 'Something Went Wrong..Please Try again')
                    })

                }
            })
    }
    
    handleRoute = () => {
        window.location.href = "/"+localStorage.getItem("role")+ '/auditteamproposal/' +this.state.reportOfreviewProcess.orgCode;
    }

    generateReviewProcess = () => {
        return axios.get(APIURL+'/api/generatepdf/get/auditteamproposalpdf/' + this.state.reportOfreviewProcess.orgCode, {
            responseType: 'arraybuffer',
            headers: {
                'Accept': 'application/pdf'
            }
        }
        ) 
            .then((response) => {
                const blob = new Blob(
                    [response.data],
                    { type: 'application/pdf' }
                )
                const link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = this.state.data.orgSerialNumber   + '- Team Proposal ' + `.pdf`
                link.click()
            })
    }

    postData = () => {
        var jsonRequest = {
            orgCode: this.state.reportOfreviewProcess.orgCode,
            auditteamurl: this.state.reportOfreviewProcess.auditteamurl,
        }
        axios.patch(APIURL + "/api/rfq/patch/auditteamurl", jsonRequest)
            .then((res) => {
                if (res.data.errorCode === 0) {
                    ToastInstance('Success', 'Stage 1 Audit Team Proposal Updated')
                }
                else {
                    ToastInstance('Error', 'Something Went Wrong')
                }
            })
            .catch(err => {
                ToastInstance('warning', 'Something Went Wrong..Please Try again')
            })

    }
    downloadSignedPdf = () => {
        const link = document.createElement('a');
        console.log("link",link)
        link.href = this.state.uploadedProcessUrl
        window.open(link)
    }
    render() {
        console.log("this.state.data.orgCode",this.state.data.orgCode)
         const FileReviewProcess = () => (
            this.state.showFile === 'Image' ?
                <>
                    <img className="img-fluid" src={this.state.reportOfreviewProcess.auditteamurl} style={{ width: '80px', height: '80px' }}  onClick={()=>this.downloadUploadPdf()}/>
                    <p>{this.state.filenameToview}</p>
                    <span>
                        <h6 onClick={() => this.removeDoc('auditteamurl')} style={{ position: "relative", top: "-65px", marginLeft: "69px" }}><i className="fas fa-times"></i></h6>
                    </span>
                </>
                :
                this.state.showFile === 'pdf' ?
                     <div className="row">
                         <div className="col-sm-12">
                             <img className="img-fluid" src="/dist/img/pdf.png" style={{ width: '60px', height: '60px' }} onClick={() => this.downloadUploadPdf()} />

                             <span>
                                 <h6 onClick={() => this.removeDoc('auditteamurl')} style={{ position: "relative", top: "-65px", marginLeft: "69px" }}><i className="fas fa-times"></i></h6>
                             </span>
                         </div>
                         <div className="row">
                             <span>{this.state.filenameToview}</span>

                         </div>
                     </div>
                    :
                    <>
                        <input type='file' ref={this.processUrlInput} onChange={this.handleprocessreview} />
                        <p style={{ fontSize: '10px', color: 'red' }}>Only Pdf and images are accpeted</p>
                    </>
        )
    if(this.state.isLoading){
            return(<h1>Loading</h1>)
        }
    return (
        <div>
           
            <div className="content-wrapper">
                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            {
                                this.state.showMessage  ?

                                    <div className="text-center"><p style={{fontSize:"25Px" ,color:"red"}}>{this.state.message}</p></div>
                                :
                                    null
                            }
                            <div className="col-sm-12">
                                <div className="card-body" style={{ paddingLeft: "50px" }}>
                                    <div className="row">
                                        <div className="col-sm-12">
                                                <div className="row">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Client Name</label>
                                                    <div className="col-sm-9">
                                                        <p>{this.state.data.orgName}</p>
                                                    </div>
                                                    </div>
                                                    <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Address</label>
                                                    <div className="col-sm-9">
                                                    <p>{this.state.data.address}</p>
                                                    </div>
                                                </div>

                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">No. of Employees</label>
                                                    <div className="col-sm-3">
                                                        <p>{this.state.data.total}</p>
                                                    </div>

                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Shifts( Ist/ IInd/ IIIrd)</label>
                                                    <div className="col-sm-3">
                                                        <p>{this.state.data.shifts}</p>               
                                                    </div>
                                                </div>

                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Effective Number of Employees to be Audited</label>
                                                    <div className="col-sm-3">
                                                        <p>{this.state.data.effectiveNoEmpToBeAudited}</p>                                                    </div>
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">No. of Sites / Temp. sites To be Audited</label>
                                                    <div className="col-sm-3">
                                                        <p>{this.state.data.nosites}</p>                                                    </div>
                                                </div>

                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Justification for Effective Number of Employees Consideration</label>
                                                    <div className="col-sm-9">
                                                        <p>{this.state.data.justificationEffNoEmpConsideration}</p>                                                    </div>
                                                        </div>

                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Contact Person with Designation Contact Number </label>
                                                    <div className="col-sm-9">
                                                    <p>{this.state.data.contactPersonName}</p>                                                    </div>
                                                </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Type Of Audit</label>
                                                    <div className="col-sm-3">
                                                    <p>{this.state.data.typeofaudit}</p>                                                    </div>
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Date Of Audit</label>
                                                    <div className="col-sm-3">
                                                    <p >{moment(this.state.data.dateofaudit).format('DD-MMM-YYYY')}</p>                                                    </div>
                                                </div>


                                                <div className="row">
                                                            <div className="headingcolor hrstyle" >
                                                                <h5>Audit Mandays</h5>
                                                            </div>
                                                        </div>
                                                           
                                                            <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-3 mt-1 labelsize"> Stage 1 Mandays</label>
                                                            <div className="col-sm-3" >
                                                            
                                                             <p>{this.state.data.stageOneAudit}</p>                                                    
                                                             </div>
                                                           
                                                            <label htmlFor="staticEmail" className="col-sm-3 mt-1 labelsize"> Stage 2 Mandays</label>

                                                            <div className="col-sm-3">
                                                            <p>{this.state.data.stageTwoAudit}</p>                                                   
    
                                                              </div>
                                                              </div>
                                                              <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-3 mt-1 labelsize"> Stage One Audit Date</label>

                                                            <div className="col-sm-3">
                                                            <p>{moment(this.state.data.auditdate1).format("DD-MM-YYYY")}</p>                                                    
                                                           </div>
                                                           <label htmlFor="staticEmail" className="col-sm-3 mt-1 labelsize"> Stage Two Audit Date</label>

                                                            <div className="col-sm-3">
                                                            <p>{moment(this.state.data.auditdate2).format("DD-MM-YYYY")}</p>                                   
    
                                                              </div>
                                                        </div>
                                                  

                                                
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Proposed Scope</label>
                                                    <div className="col-sm-9">
                                                    <p>{this.state.data.proposedscope} </p>  
                                                    </div>
                                                </div>

                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">NACE Code of Client Activity</label>
                                                    <div className="col-sm-9">
                                                    <p> {this.state.data.nabcbcodeName} </p>   
                                                    </div>
                                                    </div>
                                                    <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Risk Level</label>
                                                    <div className="col-sm-9">
                                                    <p>  {this.state.data.riskLevel}   </p>
                                                      
                                                    </div>
                                                </div>

                                                <div className="row">
                                                    <div className="headingcolor hrstyle">
                                                        <h5>No. of Man days for Audit</h5>
                                                    </div>
                                                </div>
                                                
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Offsite</label>
                                                    <div className="col-sm-3">
                                                    <p> {this.state.data.offsite}  </p> 
                                                    </div>
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Onsite</label>
                                                    <div className="col-sm-3">
                                                    <p> {this.state.data.onsite} </p>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="headingcolor hrstyle">
                                                        <h5>Audit Team</h5>
                                                    </div>
                                                </div>
                                                <div className="row mt-4">
                                                   
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Team Leader/ Lead Auditor</label>
                                                    <div className="col-sm-3">
                                                    <p>{this.state.data.teamleaderName} </p>
                                                    </div>
                                                    </div> 
                                                    {
                                                                this.state.data.technicalExpertName ?
                                                    <div className="row mt-4">
                                                        <label htmlFor="staticEmail" className="col-sm-3 labelsize">Technical expert</label>
                                                        <div className="col-sm-3">
                                                            <p>{this.state.data.technicalExpertName} </p>
                                                        </div>
                                                    </div>
                                                          :""  
                                                        }
                                                            {
                                                                this.state.data.auditorOneName ?
                                                                <div className="row mt-4">
                                                                                                                <label htmlFor="staticEmail" className="col-sm-3 labelsize">Auditor One</label>
                                                                                                                <div className="col-sm-3">
                                                                                                                <p>{this.state.data.auditorOneName} </p>
                                                                                                                
                                                                                                                </div>
                                                                                                                </div>
                                                                                                                :""  
                                                            }
                                                            {
                                                                this.state.data.auditorOneName ?
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Auditor Two</label>
                                                    <div className="col-sm-3">
                                                    <p>{this.state.data.auditorTwoName} </p>
                                                    </div>
                                                </div>
                                                :""  
                                            }

                                                <div className="row ">
                                                    <div className="headingcolor hrstyle">
                                                        <h5>Innovative Quality Certifications Pvt.  Ltd.</h5>
                                                    </div>
                                                    </div>
                                                    <div className="row mt-4">
                                                        <label htmlFor="staticEmail" className="col-sm-3 labelsize">Proposed By</label>
                                                        <div className="col-sm-3">
                                                    <p>{this.state.data.proposedname} </p>
                                                            
                                                        </div>

                                                        <label htmlFor="staticEmail" className="col-sm-3 labelsize">Approved By</label>
                                                        <div className="col-sm-3">
                                                    <p>{this.state.data.approvedname} </p>
                                                           
                                                        </div>
                                                    </div>

                                                    <div className="row mt-4">
                                                       

                                                        <div>
                                                                <div className="row mt-4">
                                                                    <hr className="mt-4" />
                                                                    <div className="col-sm-6 text-dark ">
                                                                        <h5>Download Audit Team Proposal</h5>
                                                                    </div>
                                                                   
                                                                    <div className="col-sm-4"/>
                                                                    
                                                                    <button className="btn btn-primary btn-sm col-sm-2 mb-2 ml-2" onClick={() => this.generateReviewProcess()}>Download</button>
                                                                   
                                                                </div>
                                                                <hr className="mt-4" />
                                                        </div>
                                                   {
                                                       localStorage.getItem("userRole") === 'Management' || localStorage.getItem("userRole") === 'Accounts' ? 
                                                      ""
                                                      :
                                                    <div style={{ display: this.state.uploadDocumentStatus }}>
                                                        <div className="row mt-4">
                                                            <hr className="mt-4" />
                                                            <div className="col-sm-6 text-dark ">
                                                                <h5>Upload Audit Team Proposal </h5>
                                                            </div>
                                                            
                                                            <div className="row mt-5" >
                                                                <div className="col-sm-4"><label htmlFor="staticEmail" className="labelsize">Upload Audit Team Proposal </label></div>
                                                                <div className="col-sm-6">
                                                                <p style={{color:"red" ,display:this.state.messageforvalidation}}>Please Select Size Which is less than 3 MB</p>
                                                                    {
                                                                        this.state.reportOfreviewProcess.auditteamurl !== "" ?
                                                                            <FileReviewProcess />
                                                                            :
                                                                            <>
                                                                                <input type='file' ref={this.viewprocessUrlInput} onChange={this.handleprocessreview} />
                                                                                <br></br>

                                                                            </>
                                                                    }
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-sm-6" />
                                                                <div className="col-sm-4" />
                                                                <button type="button" className="btn btn-sm btn-success col-sm-2 mb-2 mr-2" onClick={() => this.postData()} disabled={this.state.uploadStatus}>Upload</button>
                                                               

                                                            </div>

                                                        </div>
                                                        
                                                    </div>
                                                    }
                                                  

                                                  
                                                    
                                                </div>
                                                <div style={{ display: this.state.uploadedDocumentStatus }} >
                                                    <div className="row mt-5" >
                                                        <hr className="mt-4" />
                                                        <div className="col-sm-6 text-dark ">
                                                            <h5>Uploaded Audit Team Proposal</h5>
                                                        </div>
                                                        <div className="col-sm-4">

                                                            <label className="mt-4 labelsize">
                                                                Uploaded Audit Team Proposal
                                                            </label>

                                                        </div>
                                                        <div className="col-sm-6">
                                                            {
                                                                this.state.uploadedProcessUrl.match(/\.(jpg|jpeg|png|gif)$/) ?
                                                                    <>
                                                                        <img className="img-fluid" src={this.state.uploadedProcessUrl} style={{ width: '80px', height: '80px' }} onClick={()=>this.downloadSignedPdf()}/>
                                                                        <p>{this.state.uploadedFileNameToshow}</p>
                                                                        {
                                                                        localStorage.getItem("userRole") === 'Management' || localStorage.getItem("userRole") === 'Accounts'?
                                                                        ""
                                                                        :
                                                                        <span>
                                                                            <h6 onClick={() => this.removeUplodedDoc('processUrl')} style={{ position: "relative", top: "-65px", marginLeft: "69px" }}><i className="fas fa-times"></i></h6>
                                                                        </span>
                                                                        }
                                                                    </>
                                                                    :
                                                                    this.state.uploadedProcessUrl.match(/\.(pdf)$/) ?
                                                                        <>
                                                                            <img className="img-fluid mt-3" src="/dist/img/pdf.png" style={{ width: '60px', height: '60px' }}  onClick={()=>this.downloadSignedPdf()}/>
                                                                           
                                                                           { 
                                                                             localStorage.getItem("userRole") === 'Management' || localStorage.getItem("userRole") === 'Accounts'?
                                                                             ""
                                                                             :
                                                                                <span>
                                                                                    <h6 onClick={() => this.removeUplodedDoc('processUrl')} style={{ position: "relative", top: "-65px", marginLeft: "69px" }}><i className="fas fa-times"></i></h6>
                                                                                </span>
                                                                            }
                                                                             <p>{this.state.uploadedFileNameToshow}</p>
                                                                            </>

                                                                        :
                                                                        ""
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                                {
                                                      localStorage.getItem("userRole") === 'Management' || localStorage.getItem("userRole") === 'Accounts' ? 
                                                      
                                                      !this.state.uploadedProcessUrl  ?
                                                      <>
                                                     
                                                     
                                                         <div className="col-sm-6">The Signed Pdf is not yet uploaded</div>
                                                             
                                                               </> 
                                                                
                                                                :
                                                                ""
                                                                :
                                                                ""

                                                }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            
            { 
                localStorage.getItem("userRole")==="Management" || localStorage.getItem("userRole")==="Lead Auditor" || localStorage.getItem("userRole")==="Auditor" || localStorage.getItem("userRole")==="Asst Auditor" || localStorage.getItem("userRole")==="Accounts" ?
                                    ""
                    :
                     <div className="card-footer">
                                <div className="row">
                                <div className="col-sm-10"></div>
                                <div className="col-sm-2">
                                    {
                                    
                                    this.state.editStatus  ?
                                    ! this.state.uploadedProcessUrl ?

                                    <button type="submit" className="btn btn-primary float-right" onClick={() => this.handleRoute()}>Edit</button>
                                    : 
                                    <div></div>
                                    :"" 
                                    
                                
                                }
                                    </div>
                                
                            </div>
                            </div> 
    }
        </div>
        
    )
}

}